import { render, staticRenderFns } from "./doQuestionRecordSix.vue?vue&type=template&id=edff9d06&scoped=true"
import script from "./doQuestionRecordSix.vue?vue&type=script&lang=js"
export * from "./doQuestionRecordSix.vue?vue&type=script&lang=js"
import style0 from "./doQuestionRecordSix.vue?vue&type=style&index=0&id=edff9d06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edff9d06",
  null
  
)

export default component.exports